export default __webpack_public_path__ + "static/media/defendant-1.719dcc5a.jpg";